import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import { CheckoutProvider } from 'components/Checkout/CheckoutContext'
import usePayPalOptions from 'hooks/usePayPalOptions'
import useOnMount from 'hooks/useOnMount'
import { useState, type PropsWithChildren } from 'react'
import { type Stripe } from '@stripe/stripe-js'
import PaymentManager from 'services/PaymentManager'
import { lazyLoadManager } from 'services/LazyLoadManager'
import CartFlow from './CartFlow'
import StripeElementsProvider from 'components/StripeElementsProvider/StripeElementsProvider'
import { ExpressCheckoutAvailabilityProvider } from 'components/StripeExpressCheckout/ExpressCheckoutAvailabilityProvider'
import { AvailableStockProvider } from 'components/FrameProvider/AvailableStockProvider'
import { useLocation } from 'react-router'
import { useNoSSR } from 'utils/NoSSR'
import { isCartExcludedPath } from '../cart.consts'

export default function CartFlowClientWrapper({ children }: PropsWithChildren) {
  const payPalOptions = usePayPalOptions()
  const [stripe, setStripe] = useState<Stripe | null>(null)
  const { pathname } = useLocation()
  const isClient = useNoSSR()

  useOnMount(() => {
    lazyLoadManager.onStripeLoaded(() => {
      if (!window.Stripe) {
        return
      }
      setStripe(
        window.Stripe(PaymentManager.getStripeKey(), {
          betas: [
            'elements_enable_deferred_intent_beta_1',
            'link_default_integration_beta_2',
          ],
        })
      )
    })
  })

  return (
    <PayPalScriptProvider options={payPalOptions} deferLoading={false}>
      <CheckoutProvider>
        <StripeElementsProvider stripe={stripe}>
          <ExpressCheckoutAvailabilityProvider>
            <AvailableStockProvider>
              {children}
              {isClient && !isCartExcludedPath(pathname) && <CartFlow />}
            </AvailableStockProvider>
          </ExpressCheckoutAvailabilityProvider>
        </StripeElementsProvider>
      </CheckoutProvider>
    </PayPalScriptProvider>
  )
}
